import React, { useEffect, useState } from 'react';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import Button from '../../../../components/button/Button';
import { updateIndex } from '../../../../redux/actions/admin';
import Serverlog from '../serverlog/Serverlog';
import Modal from '../../../../components/modal/Modal';

interface InfoProps {
  updateIndex: (typ: any) => void;
}
const Info = (props: InfoProps) => {
  const [showServerlog, setShowServerlog] = useState(false);
  const notRunOnFlyText = ' NICHT IM LAUFENDEN BETRIEB AUSFÜHREN';
  const handleClose = () => {
    setShowServerlog(false);
  };
  useEffect(() => {
    //
  }, []);

  const update = (typ: any) => {
    props.updateIndex(typ);
  };

  return (
    <GridCellWrapper
      classes='info'
      label='Info'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <div className={'info-buttons'}>
        <Button
          tooltip={'Serverlog'}
          classes={'button'}
          key={0}
          onClickHandler={() => setShowServerlog(true)}
        >
          <i>Serverlogbuch</i>
        </Button>
      </div>
      {/*#83066 sollte entfernt werden, bleibt aber zur sicherheit erstmal auskommentiert hier stehen!!!*/}
      {/* <div className={'info-buttons'}>
        <Button
          tooltip={'Index für Aufträge aktualisieren.' + notRunOnFlyText}
          key={1}
          classes={'iconButton'}
          onClickHandler={() => update('AUFTRAG')}
        >
          <i>! AUFTRAG</i>
        </Button>
        <Button
          tooltip={'Index für Adressen aktualisieren.' + notRunOnFlyText}
          key={2}
          classes={'iconButton'}
          onClickHandler={() => update('ADRESSE')}
        >
          <i>! ADRESSE</i>
        </Button>
        <Button
          tooltip={'Index für Benutzer aktualisieren.' + notRunOnFlyText}
          key={3}
          classes={'iconButton'}
          onClickHandler={() => update('BENUTZER')}
        >
          <i>! USER</i>
        </Button>
        <Button
          tooltip={'Index für Mandant aktualisieren.' + notRunOnFlyText}
          key={4}
          classes={'iconButton'}
          onClickHandler={() => update('MANDANT')}
        >
          <i>! MANDANT</i>
        </Button>
        <Button
          tooltip={'Index für ORT aktualisieren.' + notRunOnFlyText}
          key={5}
          classes={'iconButton'}
          onClickHandler={() => update('ORT')}
        >
          <i>! ORT</i>
        </Button>{' '}
      </div>
      <div className={'info-buttons'}>
        <Button
          tooltip={'Index für VERPACKUNGEN aktualisieren'}
          key={6}
          classes={'iconButton'}
          onClickHandler={() => update('VERPACKUNG')}
        >
          <i>VERPACKUNG</i>
        </Button>{' '}
        <Button
          tooltip={'Index für GGVS aktualisieren'}
          key={7}
          classes={'iconButton'}
          onClickHandler={() => update('GEFAHRGUTKLASSE')}
        >
          <i>GEFAHRGUTKLASSE</i>
        </Button>
      </div>*/}
      <Modal show={showServerlog} closeHandler={handleClose} titel='Serverlog'>
        <div>
          <Serverlog />
        </div>
      </Modal>
    </GridCellWrapper>
  );
};
const mapStateToProps = (state: StateModel) => ({});

export default connect(mapStateToProps, {
  updateIndex,
})(Info);
